const version = '1.28.2';
export default version;
